import React, { useState, useContext, useEffect } from "react";
import {
  View,
  ScrollView,
  TouchableOpacity,
  Pressable,
  FlatList,
} from "react-native";
import ThemeContext from "@presto-contexts/ThemeContext";
import { VerticalSpacing } from "@presto-components/Spacing";
import LoadingContainer from "@presto-components/LoadingContainer";
import _ from "lodash";
import Spring from "@presto-components/Spring/Spring";
import TitleHeaderWithBack from "@presto-components/Headers/TitleHeaderWithBack";
import { useSafeArea, SafeAreaView } from "react-native-safe-area-context";
import { LineDivider } from "@presto-components/Dividers/Dividers";
import GalleryManager from "@presto-services/features/gallery/GalleryManager";
import asyncify from "../../common/Asyncify";
import SearchManager from "@presto-services/features/search/SearchManager";
const AsyncGalleryManager = asyncify(GalleryManager);
import I18n from "i18n-js";
import PrestoText from "@presto-components/PrestoText";
import {
  PrestoSolidButton,
  PrestoFramedButton,
} from "@presto-components/PrestoButton";
import UserContext from "@presto-contexts/UserContext";
import utils from "../../utils";
import RightPaneContext from "@presto-contexts/RightPaneContext";
import config from "@presto-common/config";
import RelatedItemCard from "@presto-screen-components/ItemCard/RelatedItemCard";
const AsyncSearchManager = asyncify(SearchManager);

export default function FilterOptionsMedicineScreen({ route, navigation }) {
  const { product } = route.params;
  const { theme } = useContext(ThemeContext);
  const { user } = useContext(UserContext);
  const [close, setClose] = useState(false);
  const { rightPaneOpen, setPaneState } = useContext(RightPaneContext);
  const [relatedItems, setRelatedItems] = useState([]);

  const searchRelatedItems = () => {
    let params = {
      molecule: product.other_data?.molecule,
      catalog_id: product?.catalog_id,
      stock_count: true,
      search_string: null,
      company_name: null,
      category_id: null,
      distributor: null,
      brand_name: null,
      region: null,
      therapy_area_simple: null,
      on_variation_offer: null,
      is_new: false,
      bestsellers: null,
      price_range: null,
      size: "100",
    };
    if (!config?.features?.show_all) {
      params.is_available = true;
    }
    if (user?.other_data?.medicine == 0) {
      params.medicine = user?.other_data?.medicine;
    }
    AsyncSearchManager.fuzzySearchCategoryItem(params).then(
      ([error, response]) => {
        let items = _.get(response, "hits.hits", []);
        setRelatedItems(items);
      }
    );
  };

  useEffect(() => {
    searchRelatedItems();
  }, []);

  const renderItem = ({ item, index }) => {
    return (
      <>
        <RelatedItemCard
          key={item._source.id}
          item={item._source}
          bgColor={"#F4FFF8"}
        />
        <VerticalSpacing size={10} />
      </>
    );
  };
  const renderActionSheet = ({ margin }) => {
    return (
      <ScrollView
        style={{
          flex: 1,
          backgroundColor: theme.white,
        }}
      >
        <LoadingContainer bgColor={theme.white} loading={false}>
          <SafeAreaView
            style={{
              backgroundColor: theme.white,
              marginBottom: margin,
              flex: 1,
            }}
          >
            <ScrollView
              contentContainerStyle={{
                paddingHorizontal: theme.primaryPadding,
                flex: 1,
                flexDirection: "column",
              }}
            >
              <VerticalSpacing size={30} />
              <RelatedItemCard key={product.id} item={product} />
              <VerticalSpacing size={20} />
              <View
                style={{
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <PrestoText
                  fontStyle="semibold"
                  size={14}
                  // extraStyle={{ width: 300 }}
                >
                  {I18n.t("screen_messages.similar_item")}
                </PrestoText>
              </View>
              <VerticalSpacing size={20} />
              <View style={{}}>
                <FlatList data={relatedItems} renderItem={renderItem} />
              </View>
              <VerticalSpacing size={40} />
            </ScrollView>
          </SafeAreaView>
        </LoadingContainer>
      </ScrollView>
    );
  };

  const fromSpring = close ? { margin: 0 } : { margin: -600 };
  const toSpring = close ? { margin: -600 } : { margin: 0 };

  return (
    <Spring from={fromSpring} to={toSpring}>
      {(props) => renderActionSheet(props)}
    </Spring>
  );
}
